module.exports = __webpack_public_path__ + "6a466ec1ae2cd93e4393ae502fb5d2e3.jpg";